import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from '../App';
import AdminNewsPost from '../ones/AdminNewsPost';
import RecentLeaguesSlider from '../ones/RecentLeaguesSlider';
import AdPanel from '../ones/AdPanel';
import RecentOpenMatches from '../ones/RecentOpenMatches';
import LeaderboardSlider from '../ones/LeaderboardSlider';

export default function View(props) {
  const appContext = useContext(AppContext);
  const [ ready, setReady ] = useState(false);

  

  const init = async () => {
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  

  return (
    <div className='container' style={{ padding: "0" }}>
      {/*<RecentLeaguesSlider/> */}

      <AdminNewsPost/>
      
      {/*
      <RecentOpenMatches/>
      <AdPanel/>
      <LeaderboardSlider/>
      <AdPanel/>
      */}
    </div>
  )

  
}
